import React from 'react'
import { FormattedMessage } from 'react-intl'
import { toRoman } from 'helpers'
/* eslint-disable max-len, react/no-multi-comp */

export const PENDING = (
    <FormattedMessage
        id='clan_landing.progressbar_tooltip.pending'
        defaultMessage='Ожидание начисления награды'
    />
)

export const TASK_NOT_AVAILABLE = (
    <FormattedMessage
        id='clan_landing.progressbar_tooltip.task_not_available'
        defaultMessage='Задача недоступна'
    />
)

export const TASK_TAKE_PREV_REWARD = (
    <FormattedMessage
        id='clan_landing.progressbar_tooltip.task_take_prev_reward'
        defaultMessage='Необходимо забрать награды за предыдущие задачи.'
    />
)

export const TASK_COMPLETE_PREVIOUS = (
    <FormattedMessage
        id='clan_landing.progressbar_tooltip.task_complete_previous'
        defaultMessage='Необходимо завершить предыдущую задачу.'
    />
)

export const TASK = (
    <FormattedMessage
        id='clan_landing.progressbar_tooltip.task'
        defaultMessage='Задача'
    />
)

export const LIMITS = (
    <FormattedMessage
        id='clan_landing.progressbar_tooltip.limits'
        defaultMessage='Ограничения'
    />
)

export const LIMITS_DESCRIPTION = (levelFrom, levelTo, isClanSquad) => {
    if (levelFrom === levelTo) {
        if (isClanSquad) {
            return (
                <FormattedMessage
                    id='clan_landing.progressbar_tooltip.limits_description_one_tier_squad'
                    defaultMessage='Техника {vehicleLevel} уровня. Во взводе/отряде должен быть соклановец.'
                    values={{
                        vehicleLevel: toRoman(levelFrom),
                    }}
                />
            )
        }
        return (
            <FormattedMessage
                id='clan_landing.progressbar_tooltip.limits_description_one_tier'
                defaultMessage='Техника {vehicleLevel} уровня.'
                values={{
                    vehicleLevel: toRoman(levelFrom),
                }}
            />
        )
    }
    if (isClanSquad) {
        return (
            <FormattedMessage
                id='clan_landing.progressbar_tooltip.limits_description_tiers_range_squad'
                defaultMessage='Техника {vehicleLevelFrom}-{vehicleLevelTo} уровней. Во взводе/отряде должен быть соклановец.'
                values={{
                    vehicleLevelFrom: toRoman(levelFrom),
                    vehicleLevelTo: toRoman(levelTo),
                }}
            />
        )
    }

    return (
        <FormattedMessage
            id='clan_landing.progressbar_tooltip.limits_description_tiers_range'
            defaultMessage='Техника {vehicleLevelFrom}-{vehicleLevelTo} уровней.'
            values={{
                vehicleLevelFrom: toRoman(levelFrom),
                vehicleLevelTo: toRoman(levelTo),
            }}
        />
    )
}

export const REWARD = (
    <FormattedMessage
        id='clan_landing.progressbar_tooltip.reward'
        defaultMessage='Награда'
    />
)

export const DONE = (
    <FormattedMessage
        id='clan_landing.progressbar_tooltip.done'
        defaultMessage='Задача выполнена'
    />
)

export const DONE_DESCRIPTION = (
    <FormattedMessage
        id='clan_landing.progressbar_tooltip.done_description'
        defaultMessage='Вы можете забрать награду.'
    />
)

export const REWARD_TAKEN = (
    <FormattedMessage
        id='clan_landing.progressbar_tooltip.reward_taken'
        defaultMessage='Награда получена'
    />
)

export const RULE_FULL_DAMAGE = (value, isSoloAvailable) => {
    if (isSoloAvailable) {
        return (
            <FormattedMessage
                id='clan_landing.progressbar_tooltip.rule_full_damage_solo_and_squad'
                defaultMessage='Нанести или обеспечить нанесение {value} ед. урона за бой в одиночку/во взводе или победить в составе отряда.'
                values={{
                    value,
                }}
            />
        )
    }

    return (
        <FormattedMessage
            id='clan_landing.progressbar_tooltip.rule_full_damage_squad'
            defaultMessage='Нанести или обеспечить нанесение {value} ед. урона за бой в составе взвода или победить в составе отряда.'
            values={{
                value,
            }}
        />
    )
}

export const RULE_EXP = (value, isSoloAvailable) => {
    if (isSoloAvailable) {
        return (
            <FormattedMessage
                id='clan_landing.progressbar_tooltip.rule_exp_solo_and_squad'
                defaultMessage='Заработать {value} «чистого» опыта за бой в одиночку/во взводе или победить в составе отряда.'
                values={{
                    value,
                }}
            />
        )
    }

    return (
        <FormattedMessage
            id='clan_landing.progressbar_tooltip.rule_exp_squad'
            defaultMessage='Заработать {value} «чистого» опыта за бой в составе взвода или победить в составе отряда.'
            values={{
                value,
            }}
        />
    )
}

export const RULE_FRAGS = (value, isSoloAvailable) => {
    if (isSoloAvailable) {
        return (
            <FormattedMessage
                id='clan_landing.progressbar_tooltip.rule_frags_solo_and_squad'
                defaultMessage='Уничтожить {value} ед. техники за бой в одиночку/во взводе или победить в составе отряда.'
                values={{
                    value,
                }}
            />
        )
    }

    return (
        <FormattedMessage
            id='clan_landing.progressbar_tooltip.rule_frags_squad'
            defaultMessage='Уничтожить {value} ед. техники за бой в составе взвода или победить в составе отряда.'
            values={{
                value,
            }}
        />
    )
}



// WEBPACK FOOTER //
// ./containers/ClanLanding/components/ClanSupplyTooltips/translations.jsx